import { MediaFolder } from "@/lib/config/types"
import { TreeSelectProps } from "antd"
type MoveFolderTreeNode = NonNullable<TreeSelectProps["treeData"]>[number]

export function mediaFoldersToTreeData(
    folders: MediaFolder[],
    disableFolderId: number | null,
  ): MoveFolderTreeNode[] {
    const build = (parentId: number | null): MoveFolderTreeNode[] =>
      folders
        .filter((f) => (f.parent?.id ?? null) === parentId)
        .map((f) => ({
          title: f.name,
          value: f.id,
          key: String(f.id),
          disabled: f.id === disableFolderId,
          children: build(f.id),
        }))
    return build(null)
  }